import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

import { bingDesktopHeaderImage } from '../media/bing-desktop-header';

export const responsiveSearchDesktop = {
  componentType: AdPlacementsComponentTypes.AdPlacementResponsiveSearchDesktop,
  key: 'responsive_search_desktop',
  className: 'responsive_search_desktop',
  type: 'ResponsiveSearchAdDesktop',
  associationType: 'ResponsiveSearchAdDesktop',
  localizedText: {
    previewTypeStringKey: _TL_('Responsive search ad'),
    stringKey: _TL_(''),
    headerImageAlt: _TL_('Header Image'),
  },
  previewSettings: {
    showLongHeadline: true,
    showDescription: true,
    showUrl: true,
    showAdsLabelInlineWithDescription: true,
    showAdDisclaimer: true,
    showHeaderImage: true,
    headerImage: bingDesktopHeaderImage,
    showPreviewTypeString: false,
    showImageExtension: true,
    imagePreviewAspectRatio: 1.78,
    imagePreviewHeight: 100,
  },
  styleOverrides: {
    previewContent: {
      border: 'none',
      boxShadow: 'none',
      width: '530px',
      minHeight: '110px',
      padding: '8px 16px',
    },
    adsLabel: {
      border: '1px solid #ddd',
      padding: '0 2px',
      fontSize: 11,
      fontWeight: 600,
      lineHeight: 1,
      borderRadius: 6,
      margin: '0 4px 0 0',
      display: 'inline',
      color: '#767676',
      opacity: '100%',
      position: 'static',
      maxHeight: 16,
    },
    textContainer: {
      margin: '4px 8px 0px 8px',
    },
    longHeadline: {
      fontWeight: '400',
      fontSize: '20px',
      lineHeight: '24px',
      minHeight: '28px',
      overflow: 'hidden',
    },
    finalUrl: {
      overflow: 'hidden',
      color: '#0b6a0b',
      fontSize: '14px',
      minHeight: '20px',
    },
    description: {
      color: '#333',
      fontSize: '13px',
      display: 'inline-block',
      flexGrow: 1,
    },
    descriptionParent: {
      display: 'flex',
    },
    headerImage: {
      height: 100,
    },
  },
};
